import { createMutationHook } from '../client';
import { registerConsent } from '../services/ContractsService';

export const useContractsRegisterConsent = createMutationHook(registerConsent, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});
